/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useLocation, Link, useHistory } from 'react-router-dom';
import { useCallback, useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
import { Form, Button, Input, message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import DokanIcons from '../../components/icon/DokanIcons';
import DokanPageTitle from '../../components/text/DokanPageTitle';

import General from '../../components/products/General';
import Inventory from '../../components/products/Inventory';
import Advanced from '../../components/products/Advanced';
import Status from '../../components/products/Status';
import Categories from '../../components/products/Categories';
import DokanAlert from '../../components/shared/Alert';
import { createProduct, updateProduct } from '../../redux/products/productsActions';
import { dismissAlert } from '../../redux/alerts/alertsActions';
import Downloadable from '../../components/products/Downloadable';

// Form

// import DokanItemCategoryFilter from '../../components/filter/DokanItemCategoryFilter';
// import General from './create/General';

// const useMountEffect = (fun) => useEffect(fun, []);

function ProductForm() {
    const dispatch = useDispatch();
    const activeClass = 'bg-pillColor-other rounded-full';
    const inactiveClass = '';
    const location = useLocation();
    const history = useHistory();
    const [active, isActive] = useState(0);
    const genRef = useRef(null);
    const inRef = useRef(null);
    const adRef = useRef(null);
    // const scRef = useRef(null);
    const goGeneral = () => {
        genRef?.current.scrollIntoView({ behavior: 'smooth' });
        isActive(1);
    };
    // useEffect(goGeneral, [goGeneral]);
    const goInventory = () => {
        inRef?.current.scrollIntoView({ behavior: 'smooth' });
        isActive(2);
    };

    const goAdvanced = () => {
        adRef?.current.scrollIntoView({ behavior: 'smooth' });
        isActive(3);
    };

    const [showAlert, setShowAlert] = useState(false);
    function handleSubmit() {
        setShowAlert(true);
    }
    const productData = useSelector((store) => store.products.productInputData);
    const { loading } = useSelector((store) => store.products);
    const onFinish = (values) => {
        productData.images.unshift(productData.featureImage);
        productData.images = [...productData.images, ...productData.galleryImages];
        // console.log(productData);
        if (!productData.categories.length > 0) {
            // eslint-disable-next-line no-use-before-define
            onSubmitFailed();
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            if (productData.id > 0) {
                dispatch(updateProduct({ formData: productData }));
            } else {
                dispatch(createProduct({ formData: productData }));
            }
            setTimeout(() => {
                dispatch(dismissAlert());
                // history.push('/products');
            }, 5000);
        }
    };

    const onSubmitFailed = () => {
        message.error('Product Create Failed');
    };

    useEffect(() => {
        //
    }, [dispatch]);

    return (
        <div className="grid grid-cols-1 md:grid-cols-12 min-w-full">
            <div className="bg-white sticky top-0 self-start col-span-2 h-screen">
                <div className="flex flex-row md:flex-col px-3 py-24">
                    <div
                        className={`flex justify-start items-center cursor-pointer pl-5 py-2 ${
                            active === 1 ? activeClass : inactiveClass
                        }`}
                    >
                        <div className="h-10 w-10 rounded-full shadow-sm bg-white">
                            <div className="h-full w-full object-cover p-3 rounded-full">
                                <DokanIcons icon="#product_general" />
                            </div>
                        </div>
                        <div className="pl-4 font-semibold" onClick={goGeneral}>
                            GENERAL
                        </div>
                    </div>
                    <div
                        className={`flex justify-start items-center cursor-pointer pl-5 py-2 ${
                            active === 2 ? activeClass : inactiveClass
                        }`}
                    >
                        <div className="h-10 w-10 rounded-full shadow-sm bg-white">
                            <div className="h-full w-full object-cover p-3 rounded-full">
                                <DokanIcons icon="#product_general" />
                            </div>
                        </div>
                        <div className="pl-4 font-semibold" onClick={goInventory}>
                            Inventory
                        </div>
                    </div>
                    <div
                        className={`flex justify-start items-center cursor-pointer pl-5 py-2 ${
                            active === 3 ? activeClass : inactiveClass
                        }`}
                    >
                        <div className="h-10 w-10 rounded-full shadow-sm bg-white">
                            <div className="h-full w-full object-cover p-3 rounded-full">
                                <DokanIcons icon="#product_general" />
                            </div>
                        </div>
                        <div className="pl-4 font-semibold" onClick={goAdvanced}>
                            Advanced
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-start-3 col-end-13 p-5">
                <DokanAlert />
                <div className="dokan-flex-between p-2 items-center">
                    <div className="text-dark font-extrabold">
                        <DokanPageTitle>
                            {productData.id > 0 ? 'Update' : 'Add New'} Product
                        </DokanPageTitle>
                    </div>
                    <Link to={(c) => ({ ...c, pathname: '/products' })}>
                        <div className="text-white bg-lochmara-blue p-3 rounded-md">
                            <button type="button">View Product</button>
                        </div>
                    </Link>
                </div>
                {/** Product Form */}
                <Spin tip="submitting..." spinning={loading}>
                    <Form onFinish={onFinish} onFinishFailed={onSubmitFailed}>
                        <div className="grid gap-6 grid-cols-12 grid-flow-col">
                            <div className="col-span-8">
                                <div ref={genRef} id="general">
                                    <General />
                                </div>
                                <div ref={inRef} id="inventory">
                                    <Inventory />
                                </div>
                                {productData.downloadable && (
                                    <div>
                                        <Downloadable />
                                    </div>
                                )}
                                <div ref={adRef}>
                                    <Advanced />
                                </div>
                            </div>
                            <div className="col-span-4">
                                <Status />
                                {/** product categories card */}
                                <Categories />
                                <div className="flex justify-end">
                                    <div className="pt-5">
                                        <Form.Item>
                                            <button
                                                type="submit"
                                                className="border-0 border-none bg-lochmara-blue text-white rounded-md px-5 py-3"
                                            >
                                                {productData.id > 0 ? 'Update' : 'Create'}
                                            </button>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Spin>
            </div>
        </div>
    );
}

export default ProductForm;
